import { c as _c } from "react/compiler-runtime";
import { Table, type TableProps } from '@onefootprint/ui';

// The table's header rule and row dividers would draw lines inside the card's border, and its uppercase headers
// outshout the card's title. Its cell selectors outrank a wrapper's, hence the `!`s.
const FLUSH_TABLE_CLASS_NAME = ['[&_th]:border-0! [&_td]:border-0!', '[&_th]:pb-1! [&_th]:text-[0.75rem]! [&_th]:font-medium! [&_th]:text-tertiary! [&_th_span]:normal-case', '[&_td]:text-[0.875rem]! [&_td]:leading-5! [&_th]:px-3! [&_td]:px-3!', '[&_th:first-child]:pl-4! [&_td:first-child]:pl-4! [&_th:last-child]:pr-4! [&_td:last-child]:pr-4!'].join(' ');
const FlushTable = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <div className={FLUSH_TABLE_CLASS_NAME}><Table {...props} variant="compact" /></div>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default FlushTable;